import { IAbstractEntity, IAbstractModel } from "model/abstract.model";

export type PessoaTO = IAbstractEntity & {
    tipoPessoa: string;
    status: 'ATIVO';
    dataCadastro: string;
    nomeRazaoSocial: string;
    nomeFantasia: string | null;
    nascimento: string | Date | null;
    identificacao: string;
    tipoContribuinte: string;
    inscricaoEstadual: string | null;
    inscricaoMunicipal: string | null;
    inscricaoSuframa: string | null;
    papeis: Array<string>;
    consumidorFinal: boolean;
    rg: string | null;

    enderecos: Array<Endereco>;
    contatos: Array<Contato>;
    observacoes: Array<Observacao>;
    impostosBeneficioSuframa: Array<TImpostosDeduzidos>;

    formaComissaoPrincipal: IAbstractModel;
    formasComissao: Array<IAbstractModel>;

    deduzIr: boolean;
    documentos: Array<never>;
    representantes: Array<never>;
    guias: Array<string>;
    outrosComissionados: Array<never>;
    preferencias: Preferencias | null;
};

export type Preferencias = {
    transportadoraPadrao: IAbstractModel | null;
    tabelasPreco: IAbstractModel[] | null;
    formasPagamento: IFormaPagamento[] | null;
    condicoesPagamento: ICondicaoPagamento[] | null;
};

export type Endereco = IAbstractEntity & {
    tipo: string;
    codigoPostal: string | null;
    logradouro: string;
    numero: string;
    complemento: string | null;
    bairro: string;
    municipio: IAbstractModel;
};

export type Contato = IAbstractEntity & {
    tipo: string;
    nome: string;
    telefones: Array<ContatoTelefone>;
    enderecoEletronicos: Array<ContatoEnderecoEletronico>;
};

export type ContatoTelefone = IAbstractEntity & {
    tipo: string;
    telefone: string;
};

export type ContatoEnderecoEletronico = IAbstractEntity & {
    tipo: string;
    endereco: string;
    enviaNfe: boolean;
};

export type Observacao = {
    observacao: string;
    usuario: string;
    dataHora: string;
};

export type PessoaKey = keyof PessoaTO;

export type PartialPessoa = {
    [K in keyof PessoaTO]?: PessoaTO[K];
};

export enum TImpostosDeduzidos {
    ICMS = "ICMS",
    PIS = 'PIS',
    COFINS = 'COFINS'
}
interface IFormaPagamento extends IAbstractModel {
    parcela: boolean;
}

export interface ICondicaoPagamento extends IAbstractModel {
    numeroParcelas: number;
};
